export const SAMA_BARAKA_LOGO = '/images/branding/sama-baraka-logo.png';
export const SAMA_BARAKA_SLUG = 'sama-baraka';
export const SAMA_BARAKA_PATH = `/${SAMA_BARAKA_SLUG}`;

export const SAMA_BARAKA_BRAND = {
  ar: {
    short: 'سما بركة',
    full: 'شركة سما بركة',
    tagline: 'حلول متكاملة لنقاء المياه',
  },
  en: {
    short: 'Sama Baraka',
    full: 'Sama Baraka',
    tagline: 'Complete water purity solutions',
  },
};
